export default {
  coupon: {
    selectCoupons: 'クーポンを選ぶ',
    tips: 'おすすめ <span class="orange-text">{x} coupon(s)</span> が選択され, <span class="orange-text">{y}</span>が保存されます',
    couponTips: '<span class="orange-text">{x} coupon(s)</span>が選択され,  <span class="orange-text">{y}</span>が保存されます',
    noSelectedTips: '<span class="orange-text">{x} Coupon(s)</span> が使用可能',
    changeCard: '支払いカードを引き換え',
    automaticPay: '自動支払い',
    authorized: '自動的',
    unauthorized: '非自動的',
  },
  automaticPay: {
    queryRecords: 'クローズクエリ記録',
    actionTime: '操作時間',
    actionType: '操作種類',
    actionResult: '操作結果',
    resultDesc: '結果の説明',
    activate: '開通',
    approved: '承認済み',
    rejected: '拒否されました',
    underReview: '審査中',
    autoDeductClose: '自動引き落としを停止しますか？',
    confirmSubmitClose: '自動引き落とし停止の申請を提出したかどうかを確認してください。',
    closeNotice: '申請が承認されると、システムは自動的に引き落としを行いません。支払い期限を過ぎた場合、システムは自動的に退会処理を行います。',
    cancelReasonPrompt: 'キャンセル理由を選択してください：',
    reasonPrompt: '理由を選択',
    otherReason: 'その他',
    closeReasonInput: '自動引き落とし停止の理由を入力してください。',
    installmentPlan: '分割払いプラン',
    requestSubmitted: '自動引き落とし停止の申請を提出しました。',
    underReviewNotice: '現在審査中の申請がありますので、重複して提出しないでください。',
    viewReviewResult: ['審査結果は', 'で確認できます。'],
    autoApproved: '自動承認済み',
    turnOffAutoDebit: '自動引き落としを停止しますか？',
    paymentInfo: '支払い詳細',
    paymentTime: '支払い時間',
    paymentStatus: '支払い状況',
    paymentResult: '結果の説明',
    paymentApproved: '成功',
    paymentRejected: '失敗',
  },
}
